import axios from "../config/axiosConfig";

export const getAllTransactions = async ({
  page = 1,
  limit = 10,
  coinId = [],
  type = null,
}) => {
  try {
    const response = await axios.post("/transactions/getTransaction", {
      page,
      limit,
      coinId,
      transactionType: type,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    throw error;
  }
};

export const deleteTransaction = async (id) => {
  try {
    const response = await axios.delete(`/transactions/${id}`);
    return response.status;
  } catch (error) {
    throw error;
  }
};

export const updateTransaction = async (data) => {
  try {
    const response = await axios.put(`/transactions/${data?.id}`, data);
    console.log(response);
    return response?.status;
  } catch (error) {
    throw error;
  }
};

export const createTransaction = async (data) => {
  try {
    const response = await axios.post(`/transactions`, data);
    return response?.status;
  } catch (error) {
    throw error;
  }
};

export const getAdminTransactions = async (
  page = 1,
  limit = 10,
  coinId = null,
  type = null
) => {
  try {
    const response = await axios.get("/transactions/admin", {
      params: { page, limit, coinId, type },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching filtered transactions:", error);
    throw error;
  }
};

// Create a new exchange transaction (buy or sell)
export const createExchangeTransaction = async (data) => {
  try {
    const response = await axios.post("/transactions/exchange", data);
    return response.status;
  } catch (error) {
    console.error("Error creating exchange transaction:", error);
    throw error;
  }
};

// Get exchange history for logged-in user
export const getExchangeHistory = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get("/transactions/exchange/history", {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching exchange history:", error);
    throw error;
  }
};
